import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoiceLow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconVoiceLow"><Path d="M7.75 6.75V17.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M3.75 11.25V12.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M12 10.75V13.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M16.25 8.75V15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M20.25 11.25V12.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconVoiceLow;
